import ContactQuestion from './ContactQuestion';

function PartnerShip({ question }: { question: any }) {
  return <ContactQuestion question={question} />;
}

export default PartnerShip;
